export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? null
  }
  return null
}

/**
 * cookie を書き込む。
 *
 * - SameSite=Strict でクロスサイトリクエストへの付与を防ぐ
 * - HTTPS 接続時のみ Secure フラグを付与（ローカル HTTP 開発でも動作させるため条件付き）
 * - maxAgeSeconds で有効期限を指定する（0 を指定すると即時削除と同義になるため deleteCookie を使う）
 */
export const setCookie = (
  name: string,
  value: string,
  options: { maxAgeSeconds: number },
): void => {
  const secure = location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${options.maxAgeSeconds}; SameSite=Strict${secure}`
}

/**
 * cookie を削除する。
 *
 * Max-Age=0 と expires の過去日時を併記することで、実ブラウザ / happy-dom の
 * 双方で確実に削除されることを保証する。
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; Path=/; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`
}
